<template>
<div>
    <service-form :getServiceList="getServiceList" ref="serviceFormModal"></service-form>
    <b-row class="align-items-center">
        <b-col class="d-flex align-items-center col-lg-8">
            <b-col class="col-md-3 mt-2">
                <div style="float:left;" class="custom-search d-flex justify-content-end">
                    <b-form-group>
                        <div class="d-flex align-items-center">
                            <b-form-input size="sm" v-model="searchTerm" :placeholder=" $t('others.search_name')" type="text" class="d-inline-block" />
                        </div>
                    </b-form-group>
                </div>
            </b-col>
        </b-col>
        <b-col class="col-md-4 mt-2 custom-search d-flex justify-content-end">
            <div class="d-flex align-items-right">
                <b-form-group>
                    <div class="d-flex align-items-center">
                        <b-button size="sm" variant="outline-primary" class="mr-05" v-on:keyup.enter="getServiceList()" @click="getServiceList()">{{ $t('others.list') }}</b-button>
                        <b-button style="float:right;" size="sm" variant="outline-primary" @click="getInfo(0)">{{ $t('service.add') }}</b-button>
                        <b-button style="float:right;" class="ml-1" size="sm" variant="outline-primary" @click="exportExcel()">{{ $t('excel.excel') }}</b-button>
                    </div>
                </b-form-group>
            </div>
        </b-col>
    </b-row>
    <!-- table -->
    <vue-good-table ref="serviceTable" :columns="columns" :rows="rows" styleClass="vgt-table condensed tableSize" :search-options="{
            enabled: true,
            externalQuery: searchTerm}" :select-options="{
          enabled: false,
          selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
          selectionInfoClass: 'custom-class',
          selectionText: 'rows selected',
          clearSelectionText: 'clear',
          disableSelectInfo: true, // disable the select info panel on top
          selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
        }" :pagination-options="{
          enabled: true,
          perPage:pageLength
        }" theme="my-theme">
        <div slot="emptystate">
            {{ $t('dataTable.data_not_found') }}
        </div>
        <!-- Row: Table Row -->
        <template slot="table-column" slot-scope="props">
            <span v-if="props.column.field ==='code'" class="text-nowrap">
                {{ $t('service.code') }}
            </span>
            <span v-else-if="props.column.field ==='sequenceNo'">
                {{ $t('service.sequenceNo') }}
            </span>
            <span v-else-if="props.column.field ==='name'">
                {{ $t('service.name') }}
            </span>
            <span v-else-if="props.column.field ==='tpmkCode'">
                {{ $t('service.tpmk_code') }}
            </span>
            <span v-else-if="props.column.field ==='tpmkName'" class="text-nowrap">
                {{ $t('service.tpmk_name') }}
            </span>
            <span v-else-if="props.column.field ==='ledesCode'">
                {{ $t('service.ledes_code') }}
            </span>
            <span v-else-if="props.column.field ==='department'" class="text-nowrap">
                {{ $t('service.department') }}
            </span>   
            <span v-else-if="props.column.field ==='serviceType'" class="text-nowrap">
                {{ $t('service.service_type') }}
            </span>         
            <span v-else-if="props.column.field ==='jurisdiction'">
                {{ $t('service.jurisdiction') }}
            </span>
            <span v-else-if="props.column.field ==='process'" class="text-nowrap">
                {{ $t('others.process') }}
            </span>
        </template>
        <!-- Column: Table Column -->
        <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field === 'code'">
                <span class="mb-05">
                    {{props.row.code}}
                </span>
            </span>
            <span v-else-if="props.column.field === 'sequenceNo'">
                <span style=" font-size: small" class="mb-05">
                    {{props.row.sequenceNo}}
                </span>
            </span>
            <span v-else-if="props.column.field === 'name'">
                <span style=" font-size: small" class="mb-05">
                    {{props.row.name}}
                </span>
            </span>
            <span v-else-if="props.column.field === 'tpmkCode'">
                <span class="mb-05">
                    {{props.row.tpmkCode}}
                </span>
            </span>
            <span v-else-if="props.column.field === 'tpmkName'">
                <span style=" font-size: small" class="mb-05">
                    {{props.row.tpmkName}}
                </span>
            </span>
            <span v-else-if="props.column.field === 'ledesCode'">
                <span class="mb-05">
                    {{props.row.ledesCode}}
                </span>
            </span>
            <span v-else-if="props.column.field === 'department'">
                <span style=" font-size: small" class="mb-05">
                    {{props.row.department}}
                </span>
            </span>
            <span v-else-if="props.column.field === 'serviceType'">
                <span style=" font-size: small" class="mb-05">
                    {{props.row.serviceType}}
                </span>
            </span>
            <span v-else-if="props.column.field === 'jurisdiction'">
                <span style=" font-size: small" class="mb-05">
                    {{props.row.jurisdiction}}
                </span>
            </span>
            <!-- Column: Process -->
            <span v-if="props.column.field === 'process'">
                <span>
                    <b-button v-b-tooltip.html :title=" $t('others.edit')" v-b-modal.modal-top variant="primary" class="btn-icon mb-1 ml-1" size="sm" @click="getInfo(props.row.id)">
                        <feather-icon icon="EditIcon" />
                    </b-button>
                    <b-button
                    v-b-tooltip.html
                    :title=" $t('others.delete')"
                    variant="warning"
                    class="btn-icon mb-1 ml-1"
                    size="sm"
                    @click="deleted(props.row)"
                    >
                <feather-icon icon="XIcon" />
              </b-button>
                </span>
            </span>
        </template>

        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
                <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap"> {{ $t('dataTable.total') }} {{ props.total }} {{ $t('dataTable.record') }} </span>
                    <b-form-select v-model="pageLength" :options="['10','50','100', '1000']" class="mx-1" @input="(value)=>props.perPageChanged({currentPerPage:value})" />
                    <span class="text-nowrap"> {{ $t('dataTable.row_is_show') }} </span>
                </div>
                <div>
                    <b-pagination :value="1" :total-rows="props.total" :per-page="pageLength" first-number last-number align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0" @input="(value)=>props.pageChanged({currentPage:value})">
                        <template #prev-text>
                            <feather-icon icon="ChevronLeftIcon" size="18" />
                        </template>
                        <template #next-text>
                            <feather-icon icon="ChevronRightIcon" size="18" />
                        </template>
                    </b-pagination>
                </div>
            </div>
        </template>
    </vue-good-table>
</div>
</template>

<script>
export default {
    data() {
        return {
            pageLength: 10,
            dir: false,
            columns: [{
                    label: this.$t('service.sequenceNo'),
                    field: `sequenceNo`,
                },
                {
                    label: this.$t('service.code'),
                    field: `code`,
                },
                {
                    label: this.$t('service.name'),
                    field: `name`,
                },
                {
                    label: this.$t('service.tpmk_code'),
                    field: `tpmkCode`,
                },
                {
                    label: this.$t('service.tpmk_name'),
                    field: `tpmkName`,
                },
                {
                    label: this.$t('service.ledes_code'),
                    field: `ledesCode`,
                },                
                {
                    label: this.$t('service.department'),
                    field: `department`,
                },
                {
                    label: this.$t('service.service_type'),
                    field: `serviceType`,
                },
                {
                    label: this.$t('service.jurisdiction'),
                    field: `jurisdiction`,
                },
                {
                    label: 'Process',
                    field: 'process',
                    width: '10em'
                },
            ],
            rows: [],
            searchTerm: '',
        }
    },
    mounted() {
        this.getServiceList()
    },
    methods: {
        async getInfo(id) {
            this.$refs.serviceFormModal.showInfo(id)
        },
        getServiceList() {
            this.rows = []
            const controller = {
                name: 'Service'
            }
            const payload = {
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getList', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    response.data.serviceList.forEach(element => {
                        this.rows.push(element)
                    })
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        async deleted(data) {
            data = {id: data.id}
            const controller = {name : 'Service'}
            const payload = {data: data, controller: controller}
        this.$DeleteConfirm().then(result => {
            if(result.value){
                this.$store.dispatch('moduleAuth/delete',payload).then((response) => {
                if(response.data.resultStatus == true){
                    this.$DeleteAlert()
                    this.getServiceList()
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                    this.getServiceList()
                }     
                })
            }
        })  
        },
        exportExcel() {
            const controller = {
                name: 'Service',
                actionName: 'CanExport'
            }
            const data = {
                columnList: this.columns,
                DataList: this.rows
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.$downloadFile("Service Types", response.data.base64, 'xlsx')
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        }
    },
}
</script>

<style lang="scss">
.excel-css {
    float: right;
    margin-right: 1em;
    width: 9.5em;
    color: #7367f0;
    border: 1px solid #7367f0;
    background-color: transparent;
    margin-left: 1em;
    height: 2em;
    border-radius: 0.358rem;
}

.tableSize {
    font-size: 13px !important;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: auto;
}
</style>
